module.exports = __webpack_public_path__ + "img/meeting.76b8dca7.svg";